import {
  type OrchestratedOfferingListingDetails,
  type OrchestratedAuctionListingDetails,
} from '@b-stock/fe-core/bstock-next/queries'

import { SectionRow } from '@/buyer-portal/components/SectionRow'

import { MakeAnOfferContent } from './MakeAnOfferContent'
import { useMakeAnOfferModel } from './useMakeAnOfferModel'

export const MakeAnOfferSection = ({
  listing,
}: {
  listing:
    | OrchestratedOfferingListingDetails
    | OrchestratedAuctionListingDetails
}) => {
  const model = useMakeAnOfferModel(listing)

  if (!model) return null

  return (
    <SectionRow rowPrefix="Listing.sections.makeAnOffer">
      <MakeAnOfferContent model={model} />
    </SectionRow>
  )
}
